import { render } from "./fundreport.vue?vue&type=template&id=628ea121&scoped=true"
import script from "./fundreport.vue?vue&type=script&lang=js"
export * from "./fundreport.vue?vue&type=script&lang=js"

import "./fundreport.vue?vue&type=style&index=0&id=628ea121&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628ea121"]])

export default __exports__